import { Injectable } from '@angular/core';
import { WorkshopDefectFitter } from '../models/workshop-defect-fitter.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class WorkshopDefectFitterService {

  private _endpoint: string = environment.api.endpoint;

  constructor(private httpClient: HttpClient) { }

  getByDefectId(workshopDefectId: number): Observable<WorkshopDefectFitter[]> {
    return this.httpClient.get(this._endpoint + 'workshop-defect-fitter?filter=workshopDefectId||eq||' + workshopDefectId)
    .pipe(map((data) => {
      return <WorkshopDefectFitter[]>data;
    }));
  }

  getBetweenDates(startDate: string, endDate: string): Observable<WorkshopDefectFitter[]> {
    const start = moment(startDate).format('YYYY-MM-DD');
    const end = moment(endDate).format('YYYY-MM-DD');
    return this.httpClient.get(this._endpoint + 'workshop-defect-fitter?filter=scheduledDate||gte||' + start + '&filter=scheduledDate||lte||' + end)
    .pipe(map((data) => {
      return <WorkshopDefectFitter[]>data;
    }));
  }

  assignFitter(workshopDefectId: number, fitterId: number, scheduledDate: string = null): Observable<WorkshopDefectFitter> {
    return this.httpClient.post(this._endpoint + 'workshop-defect-fitter',
    JSON.stringify({ workshopDefectId, fitterId, scheduledDate }),
    {headers: {'Content-Type': 'application/json'}}).pipe(map((data) => {
      return <WorkshopDefectFitter>data;
    }));
  }

  removeAssignment(id: number): Observable<any> {
    return this.httpClient.delete(this._endpoint + 'workshop-defect-fitter/' + id);
  }

  updateAssignment(id: number, workshopDefectId: number, fitterId: number, scheduledDate: string, hours: number = null): Observable<WorkshopDefectFitter> {
    // Also setting fitter.id alongside the scalar fitterId - same reason VOR's vehicle-select
    // does the same for vehicleId/vehicle.id: TypeORM's save() re-syncs a OneToOne's FK column
    // FROM the still-loaded relation object, so sending fitterId alone gets silently overwritten
    // back to the old value.
    return this.httpClient.put(this._endpoint + 'workshop-defect-fitter/' + id,
    JSON.stringify({ workshopDefectId, fitterId, fitter: { id: fitterId }, scheduledDate, hours }),
    {headers: {'Content-Type': 'application/json'}}).pipe(map((data) => {
      return <WorkshopDefectFitter>data;
    }));
  }
}
